module.exports = __webpack_public_path__ + "img/logo_1.96f8cc22.png";